<template>
  <div class="album">
    <ImageCard v-for="(item,idx) in files" :key="idx" :media="item"
      :width="item.width" :height="item.height" :src="item.thumbnail" :title="item.filename" />
  </div>
</template>

<script>
import ImageCard from '_c/image-card'
import { getMediaFileList } from '@/api/data'
export default {
  name: 'album',
  components: {
    ImageCard
  },
  data () {
    return {
      files: []
    }
  },
  mounted () {
    getMediaFileList(1, 10).then(res => {
      if (res.data.ok) {
        this.files = res.data.list
      }
    })
  }
}
</script>

<style scoped>
.album {
  display: inline-block;
  flex-direction: row;
  width: 100%;
  /* line-height: 0px; */
}
</style>
